<template>
  <div class="notification_list">
    <template v-if="notifications.length">
      <HeaderNotificationListItem
        v-for="(notification, key) in notifications"
        :key="key"
        :notification="notification"
        :observer="observer"
        :index="key"
      />
    </template>
    <div class="f16 noData" v-else>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 1.01148e-06H2C0.897 1.01148e-06 0 0.894001 0 1.992V14.008C0 15.106 0.897 16 2 16H5V20L11.351 16H18C19.103 16 20 15.106 20 14.008V1.992C19.9984 1.46279 19.7869 0.95583 19.412 0.582372C19.037 0.208914 18.5292 -0.000531115 18 1.01148e-06ZM14.707 11.293L13.293 12.707L10 9.414L6.707 12.707L5.293 11.293L8.586 8L5.293 4.707L6.707 3.293L10 6.586L13.293 3.293L14.707 4.707L11.414 8L14.707 11.293Z"
          fill="#3B3B3B"
        />
      </svg>

      {{ localStorage.translations.pages.common['text']['net-dannyh'] }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderNotificationListItem from 'components/header/notification/HeaderNotificationListItem'
export default {
  name: 'HeaderNotificationList',
  components: {
    HeaderNotificationListItem,
  },
  props: {
    notifications: Array,
  },
  data() {
    return {
      observer: null,
    }
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 1.0,
    })
  },
  computed: {},
  methods: {
    ...mapActions('notificationUser', ['onNotificationMakeSeen']),
    onSeen(targetIndex) {
      const targetItem = this.notifications[targetIndex]
      if (!targetItem.is_seen) {
        let data = {
          notifications: [
            {
              id: targetItem.id,
              type: targetItem.type,
            },
          ],
        }
        setTimeout(() => {
          this.onNotificationMakeSeen({ data }).then(() => {
            targetItem.is_seen = true
          })
        }, 1000)
      }
    },
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return
        }
        this.observer.unobserve(target)
        const targetIndex = target.getAttribute('data-index')
        this.onSeen(targetIndex)
      })
    },
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
}
</script>

<style lang="scss" scoped>
.notification_list {
  width: 100%;
  max-height: 360px;
  overflow-y: auto;
  padding: 10px;
  display: grid;
  gap: 10px;

  .noData {
    width: 100%;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
}
</style>
